interface WidgetItem {
  icon: string
  label: string
  value: number
  compValue: number
  percent: number | null
}

export function buildSingleStatWidget(
  data: any,
  icon: string,
  label: string,
): WidgetItem[] {
  if (!data) return []

  const ref = Array.isArray(data) ? data[0] : data
  const comp = Array.isArray(data) ? data[1] : null

  if (!ref && !comp) return []

  return [
    {
      icon,
      label,
      value: Math.floor(ref),
      compValue: Math.floor(comp),
      percent: comp ? ((ref - comp) / comp) * 100 : null,
    },
  ]
}
